import React from 'react';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import { formatSalesValue } from '../../../utils/formatUtils';

const WastageInputTable = ({
    wastageItems,
    getStockItemByName,
    hasSecondaryUnit,
    editingItemId,
    handleEditItem,
    handleRemoveItem,
    handleSubmit,
    isLoading
}) => {
    if (wastageItems.length === 0) return null;

    return (
        <div className="mt-4">
            <div className="rounded-md border overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200 text-sm text-center">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-3 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Item Name
                            </th>

                            <th className="px-3 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Rate
                            </th>

                            <th
                                className="px-3 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider"
                                colSpan="2"
                            >
                                Primary Unit
                            </th>

                            <th
                                className="px-3 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider"
                                colSpan="2"
                            >
                                Secondary Unit
                            </th>

                            <th className="px-3 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Cost
                            </th>

                            <th className="px-3 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Actions
                            </th>
                        </tr>

                        <tr>
                            <th></th>
                            <th></th>

                            <th className="px-3 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider border-r">
                                Qty
                            </th>

                            <th className="px-3 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
                                UOM
                            </th>

                            <th className="px-3 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider border-r">
                                Qty
                            </th>

                            <th className="px-3 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
                                UOM
                            </th>

                            <th></th>
                            <th></th>
                        </tr>
                    </thead>

                    <tbody className="bg-white divide-y divide-gray-200">
                        {wastageItems.map((item) => {
                            const stockItem = getStockItemByName(item.item_name);
                            const showSecondary =
                                stockItem && hasSecondaryUnit(stockItem);

                            return (
                                <tr
                                    key={item.id}
                                    className={
                                        editingItemId === item.id
                                            ? "bg-yellow-50"
                                            : ""
                                    }
                                >
                                    <td className="px-3 py-2.5">
                                        {item.item_name}
                                    </td>

                                    <td className="px-3 py-2.5">
                                        {formatSalesValue(stockItem?.Rate)}
                                    </td>

                                    {/* PRIMARY UNIT */}
                                    <td className="px-3 py-2.5">
                                        {item.mainQty || 0}
                                    </td>

                                    <td className="px-3 py-2.5">
                                        {stockItem?.primary_unit || "-"}
                                    </td>

                                    {/* SECONDARY UNIT */}
                                    {showSecondary ? (
                                        <>
                                            <td className="px-3 py-2.5">
                                                {item.subQty || 0}
                                            </td>

                                            <td className="px-3 py-2.5">
                                                {stockItem?.secondary_unit || "-"}
                                            </td>
                                        </>
                                    ) : (
                                        <>
                                            <td className="px-3 py-2.5">-</td>
                                            <td className="px-3 py-2.5">-</td>
                                        </>
                                    )}

                                    <td className="px-3 py-2.5 font-medium">
                                        {item.cost != null
                                            ? formatSalesValue(item.cost)
                                            : stockItem?.Rate
                                                ? formatSalesValue(item.quantity * parseFloat(stockItem.Rate))
                                                : "-"}
                                    </td>

                                    {/* ACTIONS */}
                                    <td className="px-3 py-2.5 space-x-2">
                                        <button
                                            className="text-blue-600 hover:text-blue-800"
                                            onClick={() => handleEditItem(item)}
                                        >
                                            <FaEdit />
                                        </button>

                                        <button
                                            className="text-red-600 hover:text-red-800"
                                            onClick={() =>
                                                handleRemoveItem(item.id)
                                            }
                                        >
                                            <FaTrashAlt />
                                        </button>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            <div className="mt-3 flex justify-between items-center">
                <div className="text-sm font-semibold text-gray-800 px-3 py-1.5 bg-gray-100 rounded-md">
                    Total Cost: {formatSalesValue(wastageItems.reduce((sum, i) => sum + (i.cost || 0), 0))}
                </div>
                <button
                    className="bg-green-100 text-green-700 font-semibold text-sm py-1.5 px-4 rounded-md hover:bg-green-200 disabled:bg-gray-400"
                    onClick={handleSubmit}
                    disabled={isLoading}
                >
                    {isLoading ? "Saving..." : "Save Wastage"}
                </button>
            </div>
        </div>
    );
};

export default WastageInputTable;